const env = {
  // REACT_APP_API_URL: "http://192.168.43.232:10001/api/v1/",
  // REACT_APP_SOCKET_URL:'ws://192.168.43.232:10002/socket/markets',

  // REACT_APP_API_URL: "http://192.168.11.14:10001/api/v1/",
  // REACT_APP_SOCKET_URL:'ws://192.168.11.14:10002/socket/markets',

  // REACT_APP_API_URL: "https://staging-www.sc-worldexchange.com/api/v1/",
  // REACT_APP_SOCKET_URL: "wss://staging-wss.sc-worldexchange.com/socket/markets",

  REACT_APP_API_URL: "https://www.sc-world-exchange.com/api/v1/",
  REACT_APP_SOCKET_URL: "wss://wss.sc-world-exchange.com/socket/markets",

  // REACT_APP_API_URL: "http://localhost:10001/api/v1/",
  // REACT_APP_SOCKET_URL: "ws://localhost:10002/socket/markets",

  REACT_APP_API_KEY: "cc6b2e80-732d-418a-9d30-234ae68a3410",
  mutable_token: false,
};

export default env;
